import styled from 'styled-components';
import { FooterLinkContainerStyled } from '../../../footer/footerLink/footerLink.styled';

export const ManagementButtonStyled = styled(FooterLinkContainerStyled)`
  cursor: pointer;
`;
